// src/api.ts
import axios from 'axios';
import { ApiResponse, EventSignupResponse, MySignupResponse, OpenPlayerResponse, ParticipantRequest } from './types';

// const API_URL = process.env.REACT_APP_API_URL;
const PLAYER_USERS_API_URL = process.env.REACT_APP_PLAYER_USERS_API_URL;
const PLAYER_USERS_X_FUNCTIONS_KEY = process.env.REACT_APP_PLAYER_USERS_X_FUNCTIONS_KEY;

const getAuthHeaders = () => {
    const token = localStorage.getItem('magic-link-jwt');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

// const api = axios.create({ baseURL: API_URL });
const playerUsersApi = axios.create({ baseURL: PLAYER_USERS_API_URL });
const playerUsersSecuredApi = axios.create({
    baseURL: PLAYER_USERS_API_URL,
    headers: { 'x-functions-key': PLAYER_USERS_X_FUNCTIONS_KEY },
});

// api.interceptors.request.use(config => {
//     Object.assign(config.headers, getAuthHeaders());
//     return config;
// });

playerUsersApi.interceptors.request.use(config => {
    Object.assign(config.headers, getAuthHeaders());
    return config;
});

playerUsersSecuredApi.interceptors.request.use(config => {
    Object.assign(config.headers, getAuthHeaders());
    return config;
});

export const addParticipant = async (eventId: string, request: ParticipantRequest) => {
    const response = await playerUsersApi.post<ApiResponse<boolean>>(`/event-signups/open/${eventId}/participants`, request);
    return response.data.data;
};

export const requestMagicLink = async (email: string): Promise<void> => {
    await playerUsersSecuredApi.post('/auth/magic-link', { email, frontendBaseUrl: window.location.origin });
};

export const verifyMagicLink = async (token: string): Promise<string> => {
    const response = await playerUsersSecuredApi.get<ApiResponse<{ token: string }>>(`/auth/magic-link/verify?token=${token}`);
    return response.data.data.token;
};

export const getEventSignup = async (eventId: string): Promise<EventSignupResponse | null> => {
    try {
        const response = await playerUsersSecuredApi.get<ApiResponse<EventSignupResponse>>(`/event-signups/open/${eventId}`);
        return response.data.data;
    } catch (error: any) {
        if (error.response && error.response.status === 403) {
            return null;
        }
        throw error;
    }
};

export const getMySignups = async (isTest?: boolean): Promise<MySignupResponse[]> => {
    try {
        const query = isTest ? '?test=true' : '';
        const response = await playerUsersSecuredApi.get<ApiResponse<MySignupResponse[]>>(`/event-signups/me/participants${query}`);
        return response.data.data;
    } catch (error: any) {
        if (error.response && error.response.status === 401) {
            return [];
        }
        throw error;
    }
};

export const getMyPlayers = async (isTest?: boolean): Promise<OpenPlayerResponse[]> => {
    try {
        const query = isTest ? '?test=true' : '';
        const response = await playerUsersSecuredApi.get<ApiResponse<OpenPlayerResponse[]>>(`/me/players${query}`);
        return response.data.data;
    } catch (error: any) {
        if (error.response && error.response.status === 401) {
            return [];
        }
        throw error;
    }
};
